
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    object: Object
  },
  computed: {
    stateColor(): string {
      if (this.object?.state?.toLowerCase().trim() == 'ok' || this.object?.state?.toLowerCase().trim() == 'reachable') return 'bg-green'
      else return 'bg-red'
    },
    stateName() {
      if (this.object?.state?.toLowerCase().trim() == 'unreachable') {
        return 'injoignable'
      } else if (this.object?.state?.toLowerCase().trim() == 'ok') {
        return 'connecté'
      } else {
        return 'inconnu'
      }
    },
    shopUrl(): string {
      return `${process.env.VUE_APP_PLATFORM_SHOP_URL}/catalog/${this.object?.ittype}`
    }
  }
})
